import React, { useState } from 'react';

import { ActionIcon, Button, Group, Space, TextInput, Title, useMantineTheme } from '@mantine/core';
import { useDebouncedValue, useDisclosure } from '@mantine/hooks';
import { IconPlus, IconSearch, IconX } from '@tabler/icons-react';
import PageHeader from 'components/PageHeader';
import { useAuth } from 'context/auth-context';

import DrawerLocationForm from './components/DrawerLocationForm';
import LocationTableContainer from './components/LocationTableContainer';

const Location = (): JSX.Element => {
  const theme = useMantineTheme();
  const { hasPerm } = useAuth();
  const locationPerm = hasPerm('EventTypeLocationMutate');

  const [addLocation, { open, close }] = useDisclosure(false);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [debouncedSearchTerm] = useDebouncedValue<string>(searchTerm, 250);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const value = e.currentTarget?.value || '';
    setSearchTerm(value);
  };
  const handleClearSearchFilter = (): void => {
    setSearchTerm('');
  };

  return (
    <>
      <PageHeader>
        <Group position='apart' align='center' noWrap>
          <Title order={1} size='h1'>
            Location
          </Title>
          <Group noWrap>
            <TextInput
              icon={<IconSearch size={theme.fontSizes.md} />}
              placeholder='Search'
              value={searchTerm}
              onChange={handleSearchChange}
              rightSection={
                !!searchTerm ? (
                  <ActionIcon onClick={handleClearSearchFilter} size='md'>
                    <IconX size={theme.fontSizes.md} />
                  </ActionIcon>
                ) : (
                  <Space />
                )
              }
            />
            <Button
              leftIcon={<IconPlus size={theme.fontSizes.md} />}
              onClick={open}
              disabled={!locationPerm}
              data-cy='addLocationButton'
            >
              Location
            </Button>
          </Group>
        </Group>
      </PageHeader>
      <LocationTableContainer searchTerm={debouncedSearchTerm} permission={locationPerm} />

      <DrawerLocationForm
        formId='create-location-form'
        opened={addLocation}
        closeHandler={close}
        type='create'
        title={<Title order={3}>Create Location</Title>}
      />
    </>
  );
};

export default Location;
